import React from "react"
import Layout from "../../shared/components/organisms/layout/layout"
import SEO from "../../shared/seo"
import WinnerContent from "../organisms/winner-content/winner-content"

const WinnersTemplate = props => {
  // var news_info=props.dataProp
  
  const [isMobile, setMobileBool] = React.useState(false)
  // send active modal to layout
  const [modalActive] = React.useState()
  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024 ? true : false)
  }
  React.useEffect(() => {
    updateDimensions()
    window.addEventListener("resize", updateDimensions)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])
  return (
    <Layout mobile={isMobile} modalActive={modalActive}>
      <SEO
        title={props.pageContext.params.metaTitulo}
        description={props.pageContext.params.metaDescripcion.metaDescripcion}
        url={"/" + props.pageContext.slug}
      />

      <WinnerContent params={props.pageContext.params} mobile={isMobile} />
    </Layout>
  )
}

export default WinnersTemplate
